import { StudentParagraph, Paragraph, WordList, StudentWordList, QuestionChoices } from 'pages/Words'
import { visibleTypes, categories as categoryKeys, layoutTypes } from 'keys'

const useAssessmentCategory = () => {
    const getPointsL = (sumWords) => {
        return sumWords * 2
    }

    const getPointsP = (sumWords) => {
        return sumWords
    }

    const categories = {
        [visibleTypes.PARAGRAPH]: {
            component: Paragraph,
            student: {
                component: StudentParagraph,
                fullHeight: true
            },
            system: {
                component: WordList,
            },
            points: getPointsP,
            bg: true,
            shadow: 3,
            layout: layoutTypes.row
        },
        [visibleTypes.WORD_GROUP]: {
            component: WordList,
            layout: "column",
            system: {
                component: WordList,
            },
            student: {
                component: StudentWordList,
                fullHeight: true
            },
            studentC: WordList,
            points: getPointsL,
            shadow: 0,
            layout: layoutTypes.column
        },
        [visibleTypes.MULTIPLE_CHOICE]: {
            component: QuestionChoices,
            layout: "row",
            layout: layoutTypes.row,
            student: {
                component: QuestionChoices,
                fullHeight: true
            },
            studentC: QuestionChoices,
            shadow: 0,
            animation: false
        }
    }

    const mappingMarkByType = {
        'MULTIPLE_CHOICE': {
            type: "MULTIPLE_CHOICE",
            ...categories.MULTIPLE_CHOICE
        },
        "TEHILIM": {
            type: "TEHILIM",
            ...categories.PARAGRAPH
        },
        "PARAGRAPH": {
            type: "PARAGRAPH",
            ...categories.PARAGRAPH
        },
        "WORD_GROUP": {
            type: "WORD_GROUP",
            ...categories.WORD_GROUP
        },
        "NONSENSE_WORDS": {
            type: "NONSENSE_WORDS",
            ...categories.WORD_GROUP
        },
        "null": {
            type: "null",
            ...categories.WORD_GROUP
        },
        "DEFAULT": {
            type: "DEFAULT",
            ...categories.WORD_GROUP
        }
    }

    return mappingMarkByType
}
export default useAssessmentCategory